import * as React from "react";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { Redirect } from "react-router";
import axios from "../../helpers/axios";
import newURL from "../../helpers/newUrl";
import { Pagination } from "@mui/material";
import moment from 'moment';

import { formatDate, formatTime } from '../../helpers/custom';
import {
  Grid,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Modal,
  Box,
  Divider,
  FormControl,
  Select,
  InputLabel,
  TextField,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Input,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation, WithTranslation } from "react-i18next";
import DiversionHeader from "./DiversionHeader";
import {
  DataGrid,
  GridRowParams,
  GridActionsCellItem,
  GridCellParams,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import {
  EditOutlined,
  Add,
  Security as SecurityIcon,
  FileCopy as FileCopyIcon,
  MoreHorizOutlined,
  CloseOutlined,
  FormatListNumberedSharp,
} from "@mui/icons-material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import fileDownload from "js-file-download";
// import { startUnleash } from "../../helpers/unleashConn";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "65%",
  height: "80%",
  overflowY: "scroll",
  p: 4,
};
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
  return (
      <Pagination
          count={count}
          page={page}
          onChange={onChange}
          color="primary"
          shape="rounded"
          variant="outlined"
          showFirstButton
          showLastButton
      
      
      
      />
  );
} 

// function CustomToolbar() {
//   return (
//     <GridToolbarContainer className="exportButton">
//       <GridToolbarExport
//         variant="contained"
//         csvOptions={{ fileName: "Incoming-waste" }}
//       />
//     </GridToolbarContainer>
//   );
// }

export interface IProps {
  user: {
    id: number;
    name: string;
    email: string;
    role: string;
    is_active: boolean;
    selectedHierarchies: any[];
    selectedHierarchyIds: any[];
  };
}

export interface IState {
  showLoader: boolean;
  pageSize: number;
  currentPage: number;
  rowCount: number;
  filter: string;
  filter_route_id: any;
  incomingWasteList: any[];
  
  transformedDate:any;
  routes: any[];
  routesRaw: any[];
  sources: any[];
  materialTypes: any[];
  anchorEl: any;
  showAddWasteByVehicle: boolean;
  showAddWasteByRawMaterial: boolean;
  showAddWasteByMassUpload: boolean;
  showAddWasteByWeighbridge: boolean;
  /**Add waste by Vehicle Form Data */
  route_id?: any;
  source?: string;
  date?: string | null;
  time?: string | null;
  vehicle?: any;
  vehicle_capacity?: any;
  percent_full?: number;
  total_waste?: number;
  recyclables_percentage?: number;
  recyclables_kg?: number;
  showCustomDateFilter: boolean;
  customFromDate?: string | null;
  customToDate?: string | null;
  durationType: string;
  organics_percentage?: number;
  organics_kg?: number;
  residual_percentage?: number;
  residual_kg?: number;
  material_type?: any;
  raw_material_in_kg?: number;
  massUploadData?: any;
  /**Add waste by Vehicle Form Data */
  vehicles: any[];
  vehiclesMapped: any;
  vehicleDensityMapped:any;
  showExportToCsv: boolean;
  fromDate?: string | null;
  toDate?: string | null;
  incomingWasteId: string;
  showDeleteDialog: boolean;
  truckPlateNumber: string;
  entryId: string;
  hideAddwastebtn: boolean;
  agents: any;
  agentsActive:any;
  agentTypes: any;
  agentName: string;
  agentMobile: string;
  agentEmail: string;
  agentType: string;
  agentCity: any[];
  agentId: string | null;
  weightOfTruckEntering: number ;
  weightOfTruckLeaving:number ,
  weightOfTruck:number ,
  editWeighbridge:boolean,
  editVehicle:boolean,
  editUUID:string,
  editMassUpload:boolean,
  routesRecyclablesMappedToValue:any,
  routesOrganicsMappedToValue:any,
  routesResidualMappedToValue:any, 
  displayWeighBridge:string,
  agent_id:any;
  container:any;
  hangar:any;
  vehicle_density:any;
  total_incoming_waste_percentage:any;
  total_incoming_waste_kg:any; 
  total_hangar_percentage:any;
  total_hangar_waste_kg:any;
  total_container_percentage:any;
  total_container_waste_kg:any;
  total_incoming_waste_volume:number,
  total_hangar_waste_volume:number,
  total_container_volume:number,
  depatureTime:any;
  arrivalTime:any;
  depatureKM:number;
  arrivalKM:number;
  error: boolean,
  errorMessage: string,
  showAddByVehicleSubmitButton:boolean,
  vehiclDriverError:boolean,
  vehicleFleetIdError:boolean,
  vehicleScheduleError:boolean,
  vehicleClusterError:boolean,
  vehicleIncomingWasteError:boolean,
  vehicleHangarError:boolean,
  vehicleContainerError:boolean,
  vehicleDateTimeError:boolean,
  ValueWrongError:boolean,
  ValueWrongErrorMsg:string,
}

class IncomingWaste extends React.Component<
  RouteComponentProps & IProps & WithTranslation,
  IState
> {
  constructor(props: RouteComponentProps & IProps & WithTranslation) {
    super(props);
    this.state = {
      showLoader: false,
      pageSize: 10,
      currentPage:0,
      rowCount: 0,
      filter: '',
      filter_route_id: 'all',
      incomingWasteList: [],
       transformedDate:'',
      routes: [],
      routesRaw: [],
      showCustomDateFilter: false,
      customFromDate: null,
      customToDate: null,
      durationType: "",
      sources: [],
      materialTypes: [],
      anchorEl: null,
      hideAddwastebtn: true,
      showAddWasteByVehicle: false,
      showAddWasteByRawMaterial: false,
      showAddWasteByMassUpload: false,
      showAddWasteByWeighbridge: false,
      route_id: "",
      source: "",
      date: null,
      time: formatDate(formatDate(new Date(), "Y-m-d")+" 00:00:00", "Y-m-d H:i:s"),
      vehicle: "",
      agents: [],
      agentsActive:[],
      total_waste: 0,
      truckPlateNumber: "",
      material_type: "",
      raw_material_in_kg: 0,
      massUploadData: {},
      vehicles: [],
      vehiclesMapped:{},
      vehicleDensityMapped:{},
      showExportToCsv: false,
      fromDate: null,
      toDate: null,
      incomingWasteId: "",
      showDeleteDialog: false,
      agentTypes: {
        paymentcollectionagent: "Payment Collection Agent",
        wastecollectionagent: "Waste Collection Agent",
        wastecollectionandpaymentagent: "Waste Collection and Payment Agent",
        plantoperator: "Plant Operator",
        plantoperatorincoming: "Plant Operator Incoming Only",
        plantoperatorsorted: "Plant Operator Sorted Only",
        plantoperatoroutgoing: "Plant Operator Outgoing Only",
      },
      entryId: "",
      agentName: "",
      agentMobile: "",
      agentEmail: "",
      agentType: "",
      agentCity: [],
      agentId: null,
      weightOfTruckEntering: 0,
      weightOfTruckLeaving:0,
      weightOfTruck:0,
      editWeighbridge:false,
      editVehicle:false,
      editUUID:'',
      editMassUpload:false,
      routesRecyclablesMappedToValue:{},
      routesOrganicsMappedToValue:{},
      routesResidualMappedToValue:{}, 
      displayWeighBridge:"",
      agent_id:'',
      container:0,
      hangar:0,
      vehicle_density:0,
      total_incoming_waste_percentage:0,
      total_incoming_waste_kg:0,
      total_hangar_percentage:0,
      total_hangar_waste_kg:0,
      total_container_percentage:0,
      total_container_waste_kg:0,
      total_incoming_waste_volume:0,
      total_hangar_waste_volume:0,
      total_container_volume:0,
      depatureTime:'',
      depatureKM:0,
      arrivalKM:0,
      arrivalTime:'',
      error: true, 
      errorMessage: '',
      showAddByVehicleSubmitButton:true,
      vehicleDateTimeError:true,
      vehiclDriverError:true,
      vehicleFleetIdError:true,
      vehicleScheduleError:true,
      vehicleClusterError:true,
      vehicleIncomingWasteError:true,
      vehicleHangarError:true,
      vehicleContainerError:true,
      ValueWrongError:true,
      ValueWrongErrorMsg:'',
    };
  }
  public componentDidMount(): void {
    // axios.get(`routes`).then(response => {
    //     this.setState({ routes: response.data.data })
    // });
    this.fetchAccessibleHierarchiesList();
    this.fetchIncomingWasteList();
    this.fetchVehicles();
    this.fetchRoutes();
    this.fetchSources();
    this.fetchMaterialTypes();
    this.fetchAgents();
    this.fetchAgentsActive();


  }
  public fetchAccessibleHierarchiesList() {
    
        // this.props.handleHierarchiesSelection(response.data.data);
       
        const accessiblehierarchies = this.props.user.selectedHierarchyIds;
        const argentineHierarchies = [2, 4, 7, 13, 14, 16, 17, 19];
        const mergedHierarchies = [...accessiblehierarchies, ...argentineHierarchies];
        const uniqueIds = Array.from(new Set(mergedHierarchies));
        const nonArgentineids = uniqueIds.filter(item => !argentineHierarchies.includes(item));
        if (nonArgentineids.length != 0) {
            this.setState({ hideAddwastebtn: false });
        }

        let hirachyId = localStorage.getItem("unleashHiearchy")

      //   const unleash = startUnleash(hirachyId)

      //   unleash.on('ready', () => {
      //     if (unleash.isEnabled('feature_diversion_incoming_weighbridge')) {
      //         console.log("enabled")
      //        this.setState({
      //         displayWeighBridge:"none" 
      //        }) 
      //     } 
      // }); 
 
}
  public fetchVehicles() {
    axios
      .get(`getListOfVehicles`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
      })
      .then((response) => {
        let vehicleMapped: any = {};
        let data: any = response.data.data;
        console.log(data)
        for (const obj of data) {
          vehicleMapped[obj.id] = obj.capacity;
        }

        this.setState({ vehicles: data,vehiclesMapped:vehicleMapped});
      });
  }

  public createADateObj(date: any){
    var timeString = date
    var timeParts = timeString.split(":");
    var hours = parseInt(timeParts[0]);
    var minutes = parseInt(timeParts[1].split(" ")[0]);
    var meridian = timeParts[1].split(" ")[1];
    var dateObj = new Date();
    dateObj.setHours(hours);
    dateObj.setMinutes(minutes);
    dateObj.setSeconds(0);
    dateObj.setMilliseconds(0);
    var localTimeString = dateObj.toLocaleTimeString([], { hour12: true });
    var localTimeParts = localTimeString.split(":");
    var localHours = parseInt(localTimeParts[0]);
    var localMinutes = parseInt(localTimeParts[1]);
    if (meridian === "PM" && localHours < 12) {
      localHours += 12;
    }
    dateObj.setHours(localHours);
    dateObj.setMinutes(localMinutes);
    var timezoneOffset = dateObj.getTimezoneOffset();
    var utcTimestamp = dateObj.getTime() + (timezoneOffset * 60000);
    var utcDate = new Date(utcTimestamp);
    var utcDateString = utcDate.toISOString();
    var utcTime = utcDateString.split("T")[1].slice(0, 8);
    var utcString = utcDateString.split("T")[0] + " " + utcTime;
    return utcString
  }

  public convertTo24Hour(time: any) {
    // Parse the time string into separate hour and minute components
    const [hourStr, minuteStr, period] = time.split(/:| /);
  
    // Convert the hour component to a 24-hour format
    let hour = parseInt(hourStr, 10);
    if (period === "AM" && hour === 12) {
      hour = 0;
    } else if (period === "PM" && hour < 12) {
      hour += 12;
    }
  
    // Create a new Date object and set the hour and minute components
    const datetime = new Date();
    datetime.setHours(hour);
    datetime.setMinutes(parseInt(minuteStr, 10));
  
    return datetime;
  }


  public convertToUTC(date: any){
    date.getUTCFullYear()
    date.getUTCMonth()
    date.getUTCDate()
    date.getUTCHours()
    date.getUTCMinutes()
    date.getUTCSeconds()
    return date;
  }
  
  public convertUtcToLocalTime = (utcTime: any) => {
    const utcMoment = moment.utc(utcTime, 'HH:mm:ss');
    const localMoment = utcMoment.local();
    const localTime = localMoment.format('YYYY-MM-DD HH:mm:ss');
    return localTime;
  };
  

  public convert(str: any) {
    var date = new Date(str),
      hours = ("0" + date.getHours()).slice(-2),
      minutes = ("0" + date.getMinutes()).slice(-2);
    return hours + ":" + minutes;
  }
  

  public fetchIncomingWasteList(
    page: number = 0,
    limit: number = this.state.pageSize
  ) {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: true,currentPage:page });
      let selectedRoute = (this.state.filter_route_id) ? this.state.routes[this.state.filter_route_id]: {};
      let options: any = {
        hierarchies: this.props.user.selectedHierarchyIds,
        filter: this.state.filter,
        page: page + 1,
        limit: limit,
        start_date: this.state.customFromDate
                ? formatDate(this.state.customFromDate, "Y-m-d")
                : "",
            end_date: this.state.customToDate
                ? formatDate(this.state.customToDate, "Y-m-d")
                : "",
      };
      if(this.state.filter_route_id && this.state.filter_route_id != "all"){
        options['selectedDropDown[id]'] = (this.state.filter_route_id) ? selectedRoute.id: '';
        options['selectedDropDown[hierarchy_id]'] = (this.state.filter_route_id) ? selectedRoute.hierarchy_id: '';
      }else{
        options['selectedDropDown'] = '';
      }
      axios
        .get(`incomingWasteListAggregate`, { params: options })
        .then((response: any) => {
          this.setState({ showLoader: false });
          let data: any = response.data.data.data;
          let incomingWasteList: any = [];
          data.map((incomingWaste: any, index: any) => {
            let transformedDate =new Date(incomingWaste.updated_at)
            console.log('plain',incomingWaste.updated_at)
            console.log(transformedDate)
      
            const userOffset = new Date().getTimezoneOffset()*60*1000;
            const localDate = new Date(transformedDate);
            const utcDate = new Date(localDate.getTime() - userOffset);
            var newDate = new Date(transformedDate.getTime()+transformedDate.getTimezoneOffset()*60*1000);

            var offset = transformedDate.getTimezoneOffset() / 60;
            var hours = transformedDate.getHours();
        
            newDate.setHours(hours - offset);   
            console.log('newdate', newDate)         
            // console.log('LOCAL',localDate);          
              incomingWasteList.push({
                id: index,
                community: incomingWaste.community_name,
                type: incomingWaste.type_of_incoming_waste,
                weight: incomingWaste.total_weight_kg,
                date: incomingWaste.date,
                source: incomingWaste.source_name,
            });
            console.log(incomingWaste.kind_of_incoming_waste);
          });
          this.setState({
            incomingWasteList: incomingWasteList,
            rowCount: response.data.data.total,
          });
        })
        .catch((error) => {
          this.setState({
            showLoader: false,
          });
          toast.error(error.response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  }

  public fetchRoutes() {
    axios
      .get(`allCommunitiesWithHierarchyLite`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
      })
      .then((response) => {
        let data: any = response.data.data;
        let routes: any = [];
        let hierarchies: any = [];
        let tempObjRecyclables: any = {};
        let tempObjOrganics: any = {};
        let tempObjResidual: any = {};
        data.map((route: any) => {
          if (!hierarchies[route.hierarchy_id]) {
            hierarchies[route.hierarchy_id] = {
              "id": route.hierarchy_id,
              "name": route.hierarchy_name,
              routes: []
            };
            hierarchies[route.hierarchy_id].routes.push({
              "type": "route",
              "id": route.id,
              "route": route.name,
              "hierarchy_id": route.hierarchy_id,
              "hierarchy_name": route.hierarchy_name
            });
          } else {
            hierarchies[route.hierarchy_id].routes.push({
              "type": "route",
              "id": route.id,
              "route": route.name,
              "hierarchy_id": route.hierarchy_id,
              "hierarchy_name": route.hierarchy_name
            });
          }
        });
        hierarchies.map((hierarchy: any) => {
          routes.push({
            "type": "hierarchy",
            "id": "all",
            "route": hierarchy.name,
            "hierarchy_id": hierarchy.id,
            "hierarchy_name": hierarchy.name
          });
          routes.push({
            "type": "multiple_routes",
            "id": "all",
            "route": "Multiple Routes",
            "hierarchy_id": hierarchy.id,
            "hierarchy_name": hierarchy.name
          });
          hierarchy.routes.map((route: any) => {
            routes.push({
              "type": "route",
              "id": route.id,
              "route": route.route,
              "hierarchy_id": route.hierarchy_id,
              "hierarchy_name": route.hierarchy_name
            });
            tempObjRecyclables[route.id] = {
              kg:0,
              edit_uuid:"",
            };
            tempObjOrganics[route.id] = {
              kg:0,
              edit_uuid:"",
            };
            tempObjResidual[route.id] = {
              kg:0,
              edit_uuid:"",
            };
          });
          
        });
        this.setState({ routes: routes, routesRaw: data,routesRecyclablesMappedToValue:tempObjRecyclables, routesOrganicsMappedToValue:tempObjOrganics,routesResidualMappedToValue:tempObjResidual });
      });
  }

  public fetchSources() {
    axios
      .get(`getSourceOfIncomingWaste`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
      })
      .then((response) => {
        let data: any = response.data.data;
        this.setState({ sources: data });
      });
  }

  public fetchAgents(page: number = 0, limit: number = this.state.pageSize) {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: true });
      let options = {
        hierarchies: this.props.user.selectedHierarchyIds,
        filter: "",
        page: page + 1,
        limit: limit,
      };
      axios
        .post(`allAgentsV2`, { params: options })
        .then((response: any) => {
          this.setState({ showLoader: false });
          let data: any = response.data.data.data;
          let agents: any = [];
          data.map((agent: any) => {
            agents.push({
              id: agent.id,
              agent_name: agent.name,
              mobile: agent.phone,
              email: agent.email,
              type_id: agent.agent_type,
            });
          });

          console.log(agents);

          this.setState({ agents: agents });
        })
        .catch((error) => {
          this.setState({
            showLoader: false,
          });
          toast.error(error.response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  }



  public fetchAgentsActive(page: number = 0, limit: number = this.state.pageSize) {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: true });
      let options = {
        hierarchies: this.props.user.selectedHierarchyIds,
        filter: "",
        page: page + 1,
        limit: limit,
      };
      axios
        .post(`allAgentsActive`, { params: options })
        .then((response: any) => {
          this.setState({ showLoader: false });
          let data: any = response.data.data.data;
          let agents: any = [];
          data.map((agent: any) => {
            agents.push({
              id: agent.id,
              agent_name: agent.name,
              mobile: agent.phone,
              email: agent.email,
              type_id: agent.agent_type,
            });
          });

          console.log(agents);

          this.setState({ agentsActive: agents });
        })
        .catch((error) => {
          this.setState({
            showLoader: false,
          });
          toast.error(error.response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  }


  public resetVehicleWaste(){
    this.setState({
    date:'',
    agent_id:'',
    vehicle:'',
    depatureTime:'',
    arrivalTime:'',
    depatureKM:0,
    arrivalKM:0,
    material_type:'',
    route_id:'',
    total_incoming_waste_percentage:0,
    total_hangar_percentage:0,
    total_container_percentage:0,
    total_container_waste_kg:0,
    total_incoming_waste_kg:0,
    total_hangar_waste_kg:0,
    total_incoming_waste_volume:0,
    total_hangar_waste_volume:0,
    total_container_volume:0,
    error: true, 
    errorMessage: '',
    showAddByVehicleSubmitButton:true,
    vehicleDateTimeError:true,
    vehiclDriverError:true,
    vehicleFleetIdError:true,
    vehicleScheduleError:true,
    vehicleClusterError:true,
    vehicleIncomingWasteError:true,
    vehicleHangarError:true,
    vehicleContainerError:true,
    ValueWrongError:true,
    ValueWrongErrorMsg:'',
    })
  }


  public isNotNullAndNotEmpty(value: any) {
    return value !== null && value !== "";
   }

  public checkForValidation(){

    const language = localStorage.getItem("language");

    if(this.isNotNullAndNotEmpty(this.state.date) == true){
      this.setState({vehicleDateTimeError:false})
    }
    if(this.isNotNullAndNotEmpty(this.state.agent_id) == true){
      this.setState({vehiclDriverError:false})
    }
    if(this.isNotNullAndNotEmpty(this.state.vehicle) == true){
      this.setState({vehicleFleetIdError:false})
    }
    if( this.isNotNullAndNotEmpty(this.state.material_type) == true){
      this.setState({vehicleScheduleError:false})
    }
    if( this.isNotNullAndNotEmpty(this.state.route_id) == true){
      this.setState({vehicleClusterError:false})
    }

    let num1 = parseInt(this.state.total_hangar_percentage)
    let num2 = parseInt(this.state.total_container_percentage)
    let num3 = parseInt(this.state.total_incoming_waste_percentage)

  if( (this.state.vehicleDateTimeError == true) || (this.state.vehiclDriverError == true) || (this.state.vehicleFleetIdError == true) || (this.state.vehicleScheduleError == true) || (this.state.vehicleClusterError == true)){
      if(language != null && language == "IDN"){
        this.setState({error:true,errorMessage: "Isi semua data yang dibutuhkan ditandai dengan"})
        }
        else{
         this.setState({error:true,errorMessage: "Please fill all required data (*)"})
        }
    }else {
      if((num1 != 0 || num2 != 0 || num3 != 0) && (num1 + num2 == num3)){
        this.setState({error:false, errorMessage:''})
      }else{
        if(language != null && language == "IDN"){
          this.setState({error:true,errorMessage: "Isi semua data yang dibutuhkan ditandai dengan"})
          }
          else{
           this.setState({error:true,errorMessage: "Please fill all required data (*)"})
          }
      }
    }
  }

  public fetchMaterialTypes() {
    axios
      .get(`getTypeOfIncomingWaste`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
      })
      .then((response) => {
        let vehicleDensityMapped: any = {};
        let data: any = response.data.data;
        for (const obj of data) {
          vehicleDensityMapped[obj.id] = obj.density;
          console.log(obj);
        }
        this.setState({ materialTypes: data,vehicleDensityMapped:vehicleDensityMapped });
        console.log(this.state.materialTypes)
      });
  }

  public render() {
    if (!localStorage.getItem("token")) {
      return <Redirect to="/login" />;
    }
    const { t } = this.props;
    const open = Boolean(this.state.anchorEl);

    // const handleMoreOptions = (event: React.MouseEvent<HTMLElement>) => {
    //   this.setState({ anchorEl: event.currentTarget });
    // };

    const handleAddWasteByVehicle = (event: any) => {
      event.preventDefault();
      let datetime: any = this.state.date ? formatDate(this.state.date, 'Y-m-d') + " "+ (this.state.time ? formatTime(this.state.time, 'H:i:s') : "00:00:00") : "";
      let arrivalTimeDate = new Date(this.state.arrivalTime); 
      let depatureTimeDate = new Date(this.state.depatureTime) 
      let arrivalTimeUTC = arrivalTimeDate; 
      let depatureTimeUTC = depatureTimeDate;

      let data: any = {
        route: this.state.routes[this.state.route_id],
        datetime: datetime,
        typesOfVehicles: this.state.vehicle,
        depatureTime: depatureTimeUTC,
        arrivalTime: arrivalTimeUTC, 
        depatureKM:this.state.depatureKM,
        arrivalKM:this.state.arrivalKM,
        material_type:this.state.material_type,
        total_incoming_waste_percentage:this.state.total_incoming_waste_percentage,
        total_incoming_waste_kg:this.state.total_incoming_waste_kg,
        total_hangar_percentage:this.state.total_hangar_percentage,
        total_hangar_waste_kg:this.state.total_hangar_waste_kg,
        total_container_percentage:this.state.total_container_percentage,
        total_container_waste_kg:this.state.total_container_waste_kg,
        sorted_agent_id : this.state.agent_id,
        total_incoming_waste_volume: this.state.total_incoming_waste_volume,
        total_hangar_waste_volume:this.state.total_hangar_waste_volume,
        total_container_volume:this.state.total_container_volume,
        editUUID : this.state.editUUID,
      };
      newURL
        .post(`addIncomingWasteByVehicleV2`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.status === 200) {
            this.setState({
              showAddWasteByVehicle: false,
              route_id: "",
              source: "",
              date: null,
              time: null,
              vehicle: "",
              percent_full: 0,
              total_waste: 0,
              recyclables_percentage: 0,
              recyclables_kg: 0,
              organics_percentage: 0,
              organics_kg: 0,
              residual_percentage: 0,
              residual_kg: 0,
              showLoader: false,
             editVehicle:false,
             editUUID:'', 
            });
            
            toast.success(response.data.messages, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            window.location.reload();
            this.fetchIncomingWasteList();
          } else {
            this.setState({
              showAddWasteByVehicle: false,
              editVehicle:false,
              source: "",
              time: null,
              percent_full: 0,
              total_waste: 0,
              recyclables_percentage: 0,
              recyclables_kg: 0,
              organics_percentage: 0,
              organics_kg: 0,
              residual_percentage: 0,
              residual_kg: 0,
              showLoader: false,
              editUUID:'',
              date:'',
              agent_id:'',
              vehicle:'',
              depatureTime:'',
              arrivalTime:'',
              depatureKM:0,
              arrivalKM:0,
              material_type:'',
              route_id:'',
              total_incoming_waste_percentage:0,
              total_hangar_percentage:0,
              total_container_percentage:0,
              total_container_waste_kg:0,
              total_incoming_waste_kg:0,
              total_hangar_waste_kg:0,
              total_incoming_waste_volume:0,
              total_hangar_waste_volume:0,
              total_container_volume:0,
              error: true, 
              errorMessage: '',
              showAddByVehicleSubmitButton:true,
              vehicleDateTimeError:true,
              vehiclDriverError:true,
              vehicleFleetIdError:true,
              vehicleScheduleError:true,
              vehicleClusterError:true,
              vehicleIncomingWasteError:true,
              vehicleHangarError:true,
              vehicleContainerError:true,
              ValueWrongError:true,
              ValueWrongErrorMsg:'',
            });
            toast.error("Incoming Waste Was Not Added", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
          window.location.reload();
          this.fetchIncomingWasteList();
        })
        .catch((error) => {
          this.setState({
            showAddWasteByVehicle: false,
            editVehicle:false,
            source: "",
            time: null,
            percent_full: 0,
            total_waste: 0,
            recyclables_percentage: 0,
            recyclables_kg: 0,
            organics_percentage: 0,
            organics_kg: 0,
            residual_percentage: 0,
            residual_kg: 0,
            showLoader: false,
            editUUID:'',
            date:'',
            agent_id:'',
            vehicle:'',
            depatureTime:'',
            arrivalTime:'',
            depatureKM:0,
            arrivalKM:0,
            material_type:'',
            route_id:'',
            total_incoming_waste_percentage:0,
            total_hangar_percentage:0,
            total_container_percentage:0,
            total_container_waste_kg:0,
            total_incoming_waste_kg:0,
            total_hangar_waste_kg:0,
            total_incoming_waste_volume:0,
            total_hangar_waste_volume:0,
            total_container_volume:0,
            error: true, 
            errorMessage: '',
            showAddByVehicleSubmitButton:true,
            vehicleDateTimeError:true,
            vehiclDriverError:true,
            vehicleFleetIdError:true,
            vehicleScheduleError:true,
            vehicleClusterError:true,
            vehicleIncomingWasteError:true,
            vehicleHangarError:true,
            vehicleContainerError:true,
            ValueWrongError:true,
            ValueWrongErrorMsg:'',
          });

          const language = localStorage.getItem("language");

          if(language != null && language == "IDN"){
            toast.error("Isi semua kolom yang dibutuhkan bertanda (*)", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }else {
            toast.error("Unexpected Error Incoming Waste Not Added", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }

          
        });
    };

    const handleAddWasteByRawMaterial = (event: any) => {
      event.preventDefault();
      this.setState({ showLoader: true });
      let datetime: any = this.state.date ? formatDate(this.state.date, 'Y-m-d') + " "+ (this.state.time ? formatTime(this.state.time, 'H:i:s') : "00:00:00") : "";
      let data: any = {
        route: this.state.routes[this.state.route_id],
        source: this.state.source,
        datetime: datetime,
        typeOfIncomingWasteList: this.state.material_type,
        kg: this.state.raw_material_in_kg,
      };
      if (!this.state.entryId) {
        // data.route = this.state.routes[this.state.route_id];
      } else {
        data.id = this.state.entryId;
        // data.community_id = this.state.routes[this.state.route_id].id;
      }
      axios
        .post(`addUpdateIncomingWaste`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({
              showAddWasteByRawMaterial: false,
              route_id: "",
              source: "",
              date: null,
              time: null,
              material_type: "",
              raw_material_in_kg: 0,
              showLoader: false,
              editMassUpload:false,
              editVehicle:false
            });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchIncomingWasteList();
          } else {
            this.setState({
              showAddWasteByRawMaterial: false,
              route_id: "",
              source: "",
              date: null,
              time: null,
              material_type: "",
              raw_material_in_kg: 0,
              showLoader: false,
            });
            this.fetchIncomingWasteList();
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showAddWasteByRawMaterial: false,
            route_id: "",
            source: "",
            date: null,
            time: null,
            material_type: "",
            raw_material_in_kg: 0,
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };


    const handleAddWasteByWeighbridge = (event: any) => {
      event.preventDefault();
      this.setState({ showLoader: true });
      let datetime: any = this.state.date ? formatDate(this.state.date, 'Y-m-d') + " "+ (this.state.time ? formatTime(this.state.time, 'H:i:s') : "00:00:00") : "";
      console.log(this.state);
      let data: any = {
        route: this.state.routes[this.state.route_id],
        datetime: datetime,
        TotalWaste : Math.abs(this.state.weightOfTruckEntering - this.state.weightOfTruckLeaving),
        sorted_agent_id : this.state.agentId,
        WeightOfTruckEntering : this.state.weightOfTruckEntering,
        WeightOfTruckLeaving : this.state.weightOfTruckLeaving,
        truckPlateNumber : this.state.truckPlateNumber,
        typeOfIncomingWaste: this.state.material_type,
      };
      if (!this.state.entryId) {
        data.route = this.state.routes[this.state.route_id];
      } else {
        data.id = this.state.entryId;
        data.community_id = this.state.route_id;
      }
      axios
        .post(`addOrUpdateWeighBridgeData`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({
              showAddWasteByWeighbridge: false,
              editWeighbridge:false,
              showLoader: false,
              route_id: "",
              date: null,
              time: null,
              weightOfTruck : 0,
              agentId : "",
              weightOfTruckEntering : 0,
              weightOfTruckLeaving :0,
              truckPlateNumber : "",
            });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchIncomingWasteList();
          } else {
            this.setState({
              showAddWasteByWeighbridge: false,
              editWeighbridge:false,
              showLoader: false,
              route_id: "",
              date: null,
              time: null,
              weightOfTruck : 0,
              agentId : "",
              weightOfTruckEntering : 0,
              weightOfTruckLeaving :0,
              truckPlateNumber : "",
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showAddWasteByRawMaterial: false,
            route_id: "",
            source: "",
            date: null,
            time: null,
            material_type: "",
            raw_material_in_kg: 0,
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

        // const handleExportToCsv = () => {
        //     if (this.state.fromDate && this.state.toDate) {
        //         let url = '/downloadIncomingWaste/';
        //         if (axios.defaults.baseURL) {
        //             let currentBaseURL: string = axios.defaults.baseURL;
        //             currentBaseURL = currentBaseURL.split('/').slice(0, 3).join('/');
        //             url = currentBaseURL + url;
        //         }
        //         window.open(url + formatDate(this.state.fromDate, 'Y-m-d') + "/" + formatDate(this.state.toDate, 'Y-m-d') + "/" + this.props.user.selectedHierarchyIds);
        //     }
        // };
    const handleMassUploadDataChange = (
      route_key: any,
      material_type: string,
      kg: any,
      edit_uuid :string
    ) => {

      console.log(edit_uuid);

      let massUploadData = this.state.massUploadData;

      console.log(massUploadData);

      if (massUploadData[route_key]) {
        massUploadData[route_key][material_type] = kg ? kg : null;
        massUploadData[route_key].edit_uuid = edit_uuid 
      } else {
        let item: any = {};
        item[material_type] = kg ? kg : null;
        massUploadData[route_key] = item;
      }
    };

    const handleAddWasteByMassUpload = (event: any) => {
      event.preventDefault();
      this.setState({ showLoader: true });
      let datetime: any = this.state.date ? formatDate(this.state.date, 'Y-m-d') + " "+ (this.state.time ? formatTime(this.state.time, 'H:i:s') : "00:00:00") : "";
      let data: any = {
        Mapping: this.state.routesRaw,
        Routes: this.state.massUploadData,
        datetime: datetime,
      };
     newURL 
        .post(`addIncomingWasteMassUpload`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          window.location.reload()
          if (response.data.success) {
            this.setState({
              showAddWasteByMassUpload: false,
              editMassUpload:false,
              massUploadData: {},
              date: null,
              time: null,
              showLoader: false,
              editVehicle:false,
              routesOrganicsMappedToValue : {},
              routesRecyclablesMappedToValue:{},
              routesResidualMappedToValue : {},
            });
            this.fetchIncomingWasteList();
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchIncomingWasteList();
          } else {
            this.setState({
              showAddWasteByMassUpload: false,
              editMassUpload:false,
              massUploadData: {},
              date: null,
              time: null,
              showLoader: false,
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showAddWasteByMassUpload: false,
            massUploadData: {},
            date: null,
            time: null,
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleExportToCsv = () => {

      const date = new Date();
      const Offset = date.getTimezoneOffset();

      this.setState({ showLoader: false });
      let data: any = {
        startDate: this.state.fromDate
          ? formatDate(this.state.fromDate, "Y-m-d")
          : "",
        endDate: this.state.toDate
          ? formatDate(this.state.toDate, "Y-m-d")
          : "",
        hierarchies: this.props.user.selectedHierarchyIds,
      };
      let url = "/node/new/api/incomingWastesExport";
      if (axios.defaults.baseURL) {
        let currentBaseURL: string = axios.defaults.baseURL;
        currentBaseURL = currentBaseURL.split("/").slice(0, 3).join("/");
        url = currentBaseURL + url;
      }
      axios({
        url:
          url +
          "/" +
          data.startDate +
          "/" +
          data.endDate +
          "/" +
          data.hierarchies
          + "/" +
          Offset
          ,
        method: "GET",
        responseType: "blob", // important
      })
        .then((response) => {
          var fileName =
            "incomingWaste" + data.startDate + "_" + data.endDate + ".csv";
          fileDownload(response.data, fileName);
          if (response.data.success) {
            toast.success(response.data.success, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleExportOfIncomingWasteByVehicleCsv = () => {

      const date = new Date();
      const Offset = date.getTimezoneOffset();

      this.setState({ showLoader: false });
      let data: any = {
        startDate: this.state.fromDate
          ? formatDate(this.state.fromDate, "Y-m-d")
          : "",
        endDate: this.state.toDate
          ? formatDate(this.state.toDate, "Y-m-d")
          : "",
        hierarchies: this.props.user.selectedHierarchyIds,
      };
      let url = "/node/new/api/incomingWasteByCommunity";
      if (axios.defaults.baseURL) {
        let currentBaseURL: string = axios.defaults.baseURL;
        currentBaseURL = currentBaseURL.split("/").slice(0, 3).join("/");
        url = currentBaseURL + url;
      }
      axios({
        url:
          url +
          "/" +
          data.startDate +
          "/" +
          data.endDate +
          "/" +
          data.hierarchies
          + "/" +
          Offset
          ,
        method: "GET",
        responseType: "blob", // important
      })
        .then((response) => {
          var fileName =
            "incomingWaste" + data.startDate + "_" + data.endDate + ".csv";
          fileDownload(response.data, fileName);
          if (response.data.success) {
            toast.success(response.data.success, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };


    const handleDeleteEntry = () => {
      this.setState({ showLoader: true });
      let data = {
        id: this.state.incomingWasteId,
      };
      axios
        .post(`deleteIncomingWaste`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          this.setState({
            showDeleteDialog: false,
            incomingWasteId: "",
            showLoader: false,
          });
          toast.success(t("Entry Deleted Successfully"), {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          this.fetchIncomingWasteList();
        })
        .catch((error) => {
          this.setState({
            showDeleteDialog: false,
            incomingWasteId: "",
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleEditEntry = (entry: any) => {

      console.log(entry);

      if(entry.kind == "weighbridge"){
        axios
        .post(`getWeighBridgeData`, {
          incoming_id : entry.id, 
        } , {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {

            console.log(response.data.weight_of_truck_entering)
          
            this.setState({
              showLoader: false,
              entryId: entry.id,
              route_id: (entry.route_id) ? this.state.routes.findIndex((route) => (route.id == entry.route_id && route.hierarchy_id == entry.hierarchy_id && (route.type == "multiple_routes" || route.type == "route"))): "",
              source: entry.source_id,
              date: entry.created_at,
              time: entry.created_at,
              material_type: entry.type_id,
              weightOfTruck : entry.weight,
              agentId : response.data.data.agent_id,
              weightOfTruckEntering : parseInt(response.data.data.weight_of_truck_entering),
              weightOfTruckLeaving : parseInt(response.data.data.weight_of_truck_leaving),
              truckPlateNumber : response.data.data.truck_license,
              editWeighbridge:true, 
            });
          }
    })
      }else if(entry.kind == "vehicle_with_info"){

         newURL 
          .post(`getIncomingWasteByVehicleV2`, {
            incoming_waste_id : entry.id, 
          } , {
            headers: { "Content-Type": "application/json" },
          })
          .then((response: any) => {
            if (response.data) {
              let date = new Date(response.data.data.IncomingWaste.created_at); 

              let depatureTime =  response.data.data.IncomingWastesVehicle.departure_time

              if( depatureTime != "00:00:00" || depatureTime != null){
                depatureTime = depatureTime
              }else{
                depatureTime = "00:00:00"
              }

              let arrivalTime = response.data.data.IncomingWastesVehicle.arrival_time;

              if( arrivalTime != "00:00:00" || arrivalTime != null){
                arrivalTime = arrivalTime
              }else{
                arrivalTime = "00:00:00"
              }

              this.setState({
              showLoader: false,
              entryId: entry.id,
              route_id: (entry.route_id) ? this.state.routes.findIndex((route) => (route.id == entry.route_id && route.hierarchy_id == entry.hierarchy_id && (route.type == "multiple_routes" || route.type == "route"))): "",
              source: entry.source_id,
              date: entry.created_at,
              agent_id:response.data.data.IncomingWastesVehicle.driver_id,
              time: entry.created_at,
              material_type:response.data.data.IncomingWaste.type_of_incoming_waste_id,
              vehicle:response.data.data.IncomingWastesVehicle.fleet_id,
              vehicle_capacity: this.state.vehiclesMapped[response.data.data.IncomingWastesVehicle.fleet_id],
              vehicle_density:this.state.vehicleDensityMapped[response.data.data.IncomingWaste.type_of_incoming_waste_id],
              total_incoming_waste_percentage:response.data.data.IncomingWastesVehicle.percentage_of_total,
              total_incoming_waste_kg:response.data.data.IncomingWastesVehicle.weight_total,
              total_hangar_percentage:response.data.data.IncomingWastesVehicle.percentage_of_hangar,
              total_hangar_waste_kg:response.data.data.IncomingWastesVehicle.weight_hangar,
              total_container_percentage:response.data.data.IncomingWastesVehicle.percentage_of_container,
              total_container_waste_kg:response.data.data.IncomingWastesVehicle.weight_container,
              total_incoming_waste_volume:response.data.data.IncomingWastesVehicle.volume_total,
              total_hangar_waste_volume:response.data.data.IncomingWastesVehicle.volume_hanger,
              total_container_volume:response.data.data.IncomingWastesVehicle.volume_container,
              depatureTime: depatureTime,
              depatureKM:response.data.data.IncomingWastesVehicle.departure_KM,
              arrivalKM:response.data.data.IncomingWastesVehicle.arrival_KM,
              arrivalTime:arrivalTime, 
              editUUID:response.data.data.IncomingWaste.edit_uuid,
              editVehicle:true,
              showAddWasteByVehicle:true 
              });
            }
            this.checkForValidation()
      }) 
      } else if(entry.kind == "massupload"){
        newURL 
         .post(`getIncomingWasteByMassUpload`, {
           id : entry.id, 
         } , {
           headers: { "Content-Type": "application/json" },
         })
         .then((response: any) => {
           if (response.data) {
            response.data.data.forEach((key: any) => {
              if(key.type_of_incoming_waste_id == 1){
                this.state.routesRecyclablesMappedToValue[key.route_id].kg = key.kg;
                this.state.routesRecyclablesMappedToValue[key.route_id].edit_uuid = key.edit_uuid;
              }else if(key.type_of_incoming_waste_id == 2){
                this.state.routesOrganicsMappedToValue[key.route_id].kg  = key.kg;
                this.state.routesOrganicsMappedToValue[key.route_id].edit_uuid = key.edit_uuid;
              }else if(key.type_of_incoming_waste_id == 3){
                this.state.routesResidualMappedToValue[key.route_id].kg  = key.kg; 
                this.state.routesResidualMappedToValue[key.route_id].edit_uuid = key.edit_uuid;
              }
            })
            this.setState({
             showLoader: false,
             entryId: entry.id,
             date: entry.created_at,
             time: entry.created_at, 
             editMassUpload:true, 
             });
          }
     }) 
     }
      else{
        this.setState({
          showAddWasteByRawMaterial: true,
          entryId: entry.id,
          route_id: (entry.route_id) ? this.state.routes.findIndex((route) => (route.id == entry.route_id && route.hierarchy_id == entry.hierarchy_id && (route.type == "multiple_routes" || route.type == "route"))): "",
          source: entry.source_id,
          date: entry.created_at,
          time: entry.created_at,
          material_type: entry.type_id,
          raw_material_in_kg: entry.weight,
          editUUID: "",
        });
      }
    }
    

    const columns: any = [
      {
        headerName: t("Community"),
        field: "community",
        width: 250,
      },
      {
        headerName: t("Type"),
        field: "type",
        width: 250,
      },
      {
        headerName: t("Weight"),
        field: "weight",
        type: "number",
        width: 120,
        renderCell: (params: GridCellParams) => (
          <div>{parseFloat(params.row.weight.toString()).toLocaleString()}</div>
        )
      },
      {
        headerName: "Source", 
        field: "source",
        type: "text",
        width: 250,
      },
      {
        headerName: "Date", 
        field: "date",
        type: "text",
        width: 250,
      },
      {
        headerName: "Id",
        field: "id",
        width: 100,
        hide: true,
      },
      // {
      //   headerName: "Kind Of Incoming Waste",
      //   field: "kind",
      //   width: 75,
      // },
      // {
      //   headerName: t("CreatedAt"),
      //   field: "created_at",
      //   type: "dateTime",
      //   width: 250,
      // },
      // {
      //   headerName: t("Updated At"),
      //   field: "updated_at",
      //   type: "dateTime",
      //   width: 250,
      // },
      // {
      //   headerName: t("Actions"),
      //   field: "actions",
      //   type: "actions",
      //   getActions: (params: GridRowParams) => [
      //     <GridActionsCellItem
      //       // icon={<FileCopyIcon />}
      //       label={t("Edit Type")}
      //       onClick={() => handleEditEntry(params.row)}
      //       showInMenu
      //     />,
      //     <GridActionsCellItem
      //       label={t("Delete")}
      //       onClick={() =>
      //         this.setState({
      //           incomingWasteId: params.id.toString(),
      //           showDeleteDialog: true,
      //         })
      //       }
      //       showInMenu
      //     />,
      //   ],
      // },
    ];

    return (
      <div>
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
          open={this.state.showLoader}
          // onClick={() => this.setState({ showLoader: false })}
        >
          <CircularProgress className="customLoader" />
        </Backdrop>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
<DiversionHeader user={this.props.user} />
        <Grid container spacing={2}>
          <Grid item md={12} xs={12} className="mt-3">
            <Card>
              <CardHeader
                title={
                  <Grid container spacing={2}>
                      <Grid item md={3} xs={12}>
                          <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Incoming Waste")}</Typography>
                      </Grid>
                      <Grid item md={3} xs={12}>
                          <FormControl fullWidth={true} size="small">
                              <TextField
                                  id="filter-input"
                                  label={t("Search")}
                                  name="filter"
                                  value={this.state.filter}
                                  onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.fetchIncomingWasteList())}
                                  fullWidth={true}
                                  size="small"
                              />
                          </FormControl>
                      </Grid>
                      <Grid item md={3} xs={12}>
                          <FormControl fullWidth={true} size="small">
                            <InputLabel id="routes-select-label">{t("Community")}</InputLabel>
                            <Select
                              labelId="routes-select-label"
                              value={this.state.filter_route_id}
                              onChange={(e) => this.setState({ filter_route_id: e.target.value }, () => this.fetchIncomingWasteList())}
                              displayEmpty
                              label={t("Community")}
                              fullWidth={true}
                            >
                              <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                              {
                                this.state.routes.map((route, key) => {
                                  if(route.type == "hierarchy"){
                                    return <MenuItem key={key} value={key} disabled={true}>{route.route}</MenuItem>;
                                  } else if(route.type == "multiple_routes"){
                                    return <MenuItem key={key} value={key}>&nbsp;&nbsp;{route.route}</MenuItem>;
                                  } else{
                                    return <MenuItem key={key} value={key}>&nbsp;&nbsp;{route.route}</MenuItem>;
                                  }
                                })
                              }
                            </Select>
                          </FormControl>
                      </Grid>
                      <Grid item md={3} xs={12}>
                              <FormControl fullWidth={true} size="small">
                                  <Button
                                      variant="contained"
                                      size="small"
                                      sx={{ marginTop: "5px" }}
                                      onClick={() =>
                                          this.setState({
                                              showCustomDateFilter: true,
                                              durationType: "IncomingWaste",
                                          })
                                      }
                                  >
                                      {t("Date Search")}
                                  </Button>
                              </FormControl>
                       </Grid>
                  </Grid>
                }
                className="text-left"
                action={
                  // <IconButton aria-label="customer-more-options-button" sx={{ outline: 'none !important' }} onClick={(e: any) => handleMoreOptions(e)}>
                  //     <MoreHorizOutlined id="customer-more-options-button" sx={{ outline: 'none !important' }} />
                  //     <Menu
                  //         id="customer-more-options-menu"
                  //         aria-labelledby="customer-more-options-button"
                  //         anchorEl={this.state.anchorEl}
                  //         open={open}
                  //         onClose={() => this.setState({ anchorEl: null })}
                  //         anchorOrigin={{
                  //             vertical: 'top',
                  //             horizontal: 'left',
                  //         }}
                  //         transformOrigin={{
                  //             vertical: 'top',
                  //             horizontal: 'left',
                  //         }}
                  //     >
                  //         <MenuItem className='customMenuItem' onClick={() => this.setState({ anchorEl: null })}>Synchronise</MenuItem>
                  //         <MenuItem className='customMenuItem' onClick={() => this.setState({ anchorEl: null })}>Export List</MenuItem>
                  //         <MenuItem className='customMenuItem' onClick={() => this.setState({ anchorEl: null })}>Reset List</MenuItem>
                  //     </Menu>
                  // </IconButton>
                  <CardActions>
                    {/* <Button variant="contained" size="small" className="viewHistoricalCharts" sx={{ marginRight: "8px" }} component={Link} to={'/incoming-waste-charts'}>{t("View Historical Charts")}</Button> */}
                    <Button variant="contained" size="small" sx={{ outline: "none !important" }} onClick={() => this.setState({ showExportToCsv: true })}>{t("Export To CSV")}</Button>
                  </CardActions>
                }
              />
              <CardActions>
              {
                        (!this.state.hideAddwastebtn) &&
                <Button
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() => this.setState({ showAddWasteByVehicle: true, date: null, time: formatDate(formatDate(new Date(), "Y-m-d")+" 00:00:00", "Y-m-d H:i:s") })}
                >
                  <Add /> {t("Add Waste By Vehicle")}
                </Button>
                 }
                <Button
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() =>
                    this.setState({ showAddWasteByRawMaterial: true })
                  }
                >
                  <Add /> {t("Add Waste By Raw Material")}
                </Button>
                <Button
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() =>
                    this.setState({ showAddWasteByMassUpload: true })
                  }
                >
                  <Add /> {t("Add Mass Upload")}
                </Button>
                <Button
                  variant="contained"
                  sx={{ outline: "none !important",display: this.state.displayWeighBridge }}
                  onClick={() =>
                    this.setState({ showAddWasteByWeighbridge: true })
                  }
                >
                  <Add /> {t("Show Add Waste By Weighbridge")}
                </Button>
              </CardActions>
              <CardContent>
                <DataGrid
                  aria-label={t("Incoming Waste List")}
                  columns={columns}
                  rows={this.state.incomingWasteList}
                  rowCount={this.state.rowCount}
                  pageSize={this.state.pageSize}
                  onPageChange={(page) => this.fetchIncomingWasteList(page)}
                  onPageSizeChange={(newPageSize) => {
                    this.setState({ pageSize: newPageSize });
                    this.fetchIncomingWasteList(0, newPageSize);
                  }}
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  autoHeight={true}
                  pagination
                  components={{
                    MoreActionsIcon: EditOutlined,
                    // Toolbar: CustomToolbar,
                    Pagination: () => (
                      <CustomPagination
                          count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                          page={this.state.currentPage+1}
                          onChange={(event, page) => this.fetchIncomingWasteList(page-1)}
                        
                      />
                  )
                  }}
                  paginationMode="server"
                  componentsProps={{
                    toolbar: {
                      csvOptions: { fileName: "Incoming-waste-list" },
                    },
                  }}
                  // checkboxSelection
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Modal
          open={this.state.showAddWasteByVehicle || this.state.editVehicle}
          onClose={() => { this.setState({ showAddWasteByVehicle: false, editVehicle:false })
                  this.resetVehicleWaste()
        }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card component={'form'}  onSubmit={(event: any) => handleAddWasteByVehicle(event)}>
              <CardHeader 
                title={t("Add Waste By Vehicle")}
                className="text-left"
         
                action={
                  <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddWasteByVehicle: false,editVehicle:false })}>
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true} >
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          views={['year', 'month', 'day']}
                          renderInput={(props) => <TextField {...props} />}
                          label={t("Date" + "*")}
                          value={this.state.date}
                          onChange={(newValue: any) => {
                            this.setState({ date: newValue },() =>{this.checkForValidation()});
                          }}
                          disableFuture={true}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="sorting-agent-select-label">{t("Driver")} *</InputLabel>
                                            <Select
                                                labelId="sorting-agent-select-label"
                                                value={this.state.agent_id}
                                                onChange={(e) => {
                                                  console.log(this.state.agentId)
                                                  this.setState({ agent_id: e.target.value},() =>{this.checkForValidation()})
                                              }}
                                                displayEmpty
                                                label={t("Sorting Agent") + " *"}
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.agentsActive.map((sorting_agent: any) => {
                                                        return <MenuItem key={sorting_agent.id} value={sorting_agent.id}>{sorting_agent.agent_name}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="vehicles-select-label">{t("Fleet ID" + "*")}</InputLabel>
                      <Select
                        labelId="vehicles-select-label"
                        value={this.state.vehicle}
                        onChange={(e) => {this.setState({ vehicle: e.target.value, vehicle_capacity: this.state.vehiclesMapped[e.target.value]},() =>{this.checkForValidation()})
               
                        }}
                        displayEmpty
                        label={t("Vehicle")}
                        fullWidth={true}
                      >
                        {
                          this.state.vehicles.map((vehicle) => {
                            return <MenuItem key={vehicle.id} value={vehicle.id}>{vehicle.name}</MenuItem>
                          })
                        }
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <TimePicker
                          inputFormat="hh:mm a"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("Depature Time")}
                          value={this.state.depatureTime}
                          onChange={(newValue: any) => {
                            this.setState({ depatureTime: newValue },() =>{this.checkForValidation()});
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>

                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <TimePicker
                          inputFormat="hh:mm a"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("Arrival Time")}
                          value={this.state.arrivalTime}
                          onChange={(newValue: any) => {
                            this.setState({ arrivalTime: newValue },() =>{this.checkForValidation()});
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextField
                      id="vehicle-capacity-input"
                      label={t("Depature KM")}
                      value={this.state.depatureKM}
                      onChange={(e) =>
                        this.setState({ depatureKM: Number.parseInt(e.target.value) },() =>{this.checkForValidation()})
                      }
                      type="number"
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextField
                      id="vehicle-capacity-input"
                      label={t("Arrival KM")}
                      value={this.state.arrivalKM}
                      onChange={(e) =>
                        this.setState({ arrivalKM: Number.parseInt(e.target.value) },() =>{this.checkForValidation()})
                      }
                      type="number"
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                      <FormControl fullWidth={true}>
                        <InputLabel id="material-types-select-label">
                          {t("Schedule" + "*")}
                        </InputLabel>
                        <Select
                          labelId="material-types-select-label"
                          value={this.state.material_type}
                          onChange={(e) => {
                            this.setState({ material_type: e.target.value ,vehicle_density:this.state.vehicleDensityMapped[e.target.value]},() =>{this.checkForValidation()})
                          }}
                          displayEmpty
                          label={t("Schedule")}
                          fullWidth={true}
                          required
                        >
                          {this.state.materialTypes.map((materialType, key) => {
                            return (
                              <MenuItem key={key} value={materialType.id}>
                                {materialType.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <FormControl fullWidth={true}>
                        <InputLabel id="routes-select-label">{t("Cluster" + "*")}</InputLabel>
                        <Select
                          labelId="routes-select-label"
                          value={this.state.route_id}
                          onChange={(e) => {this.setState({ route_id: e.target.value},() =>{this.checkForValidation()})
                 
                        }}
                          displayEmpty
                          label={t("Cluster")}
                          fullWidth={true}
                          required
                        >
                          {
                            this.state.routes.map((route, key) => {
                              if(route.type == "hierarchy"){
                                return <MenuItem key={key} value={key} disabled={true}>{route.route}</MenuItem>;
                              } else if(route.type == "multiple_routes"){
                                return <MenuItem key={key} value={key}>&nbsp;&nbsp;{route.route}</MenuItem>;
                              } else{
                                return <MenuItem key={key} value={key}>&nbsp;&nbsp;{route.route}</MenuItem>;
                              }
                            })
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                        id="percent-full-input"
                        label={t("%Of Incoming Waste" + "*")}
                        value={this.state.total_incoming_waste_percentage}
                        type="number"
                        InputProps={{
                            inputProps: { min: 0, max: 100000000 }
                        }}
                        onChange={(e: any) => {
                          this.setState({total_incoming_waste_percentage:e.target.value, total_incoming_waste_kg: (this.state.vehicle_capacity * e.target.value) / 100  * this.state.vehicle_density , total_incoming_waste_volume: ((this.state.vehicle_capacity * e.target.value) / 100 )   },() =>{this.checkForValidation()})
                     
                      }}
                        fullWidth={true}
                        required
                    />
                </Grid>
                  <Grid item md={4} xs={8}>
                    <TextField
                      id="recyclables-percent"
                      label={t("%In Hangar" + "*")}
                      value={this.state.total_hangar_percentage}
                      type="number"
                      InputProps={{
                        inputProps: { min: 0, max: 100000000 }
                      }}
                      onChange={(e: any) => {
                      this.setState({ total_hangar_percentage: e.target.value, total_hangar_waste_kg: (e.target.value * this.state.vehicle_capacity) / 100 * this.state.vehicle_density  ,total_hangar_waste_volume: ( (e.target.value * this.state.vehicle_capacity) / 100 ) },() =>{this.checkForValidation()})
                 
                    }}
                      fullWidth={true}
                      required
                    />
                  </Grid>
                  <Grid item md={4} xs={8}>
                    <TextField
                      id="organics-percent"
                      label={t("%In Container")}
                      value={this.state.total_container_percentage}
                      type="number"
                      InputProps={{
                        inputProps: { min: 0, max: 100000000 }
                      }}
                      onChange={(e: any) => {this.setState({ total_container_percentage: e.target.value, total_container_waste_kg:  (e.target.value * this.state.vehicle_capacity) / 100 * this.state.vehicle_density , total_container_volume:  (e.target.value * this.state.vehicle_capacity) / 100  },() =>{this.checkForValidation()})
                    }}
                      fullWidth={true}
                      required
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                  <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                  {t("Volume In Incoming")} {this.state.total_incoming_waste_volume} m3
        </Typography>
                </Grid>
                <Grid item md={4} xs={12}>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {t("Volume In Hangar")}   {this.state.total_hangar_waste_volume} m3 
        </Typography>
                </Grid>
                <Grid item md={4} xs={12}>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {t("Volume In Container")} {this.state.total_container_volume} m3
        </Typography>
                </Grid>
                </Grid>
                <Divider className='mt-3' />
              </CardContent>
              <CardActions className='float-left'>
             {this.state.error && (
                 <Typography variant="subtitle1" gutterBottom>
                 {this.state.errorMessage}
               </Typography>
             )}
             
             {this.state.ValueWrongError && (
                      <Typography variant="subtitle1" gutterBottom>
                      {this.state.ValueWrongErrorMsg}
                    </Typography>)}
              </CardActions>
              <CardActions className='float-right'>
                <Button size='small' className='customCloseButton' 
                  onClick={() => {
                  this.setState({ showAddWasteByVehicle: false ,editVehicle:false})
                  this.resetVehicleWaste() }}>{t("Close")}</Button>
                <Button size='small' disabled = {this.state.error} type='submit' variant='contained' sx={{ outline: 'none !important' }}>{t("Add Waste")}</Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showAddWasteByRawMaterial}
          onClose={() => this.setState({ showAddWasteByRawMaterial: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card component={'form'} onSubmit={(event: any) => handleAddWasteByRawMaterial(event)}>
              <CardHeader
                title={(!this.state.entryId) ? t("Add Waste By Raw Material") : t("Edit Entry")}
                className="text-left"
                action={
                  <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddWasteByRawMaterial: false })}>
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          views={['year', 'month', 'day']}
                          renderInput={(props) => <TextField {...props} />}
                          label={t("Date")}
                          value={this.state.date}
                          onChange={(newValue: any) => {
                            this.setState({ date: newValue });
                          }}
                          disableFuture={true}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <TimePicker
                          inputFormat="HH:mm"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("Time")}
                          value={this.state.time}
                          onChange={(newValue: any) => {
                            this.setState({ time: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  {
                    // (!this.state.entryId) &&
                    <Grid item md={4} xs={12}>
                      <FormControl fullWidth={true}>
                        <InputLabel id="routes-select-label">{t("Community")}</InputLabel>
                        <Select
                          labelId="routes-select-label"
                          value={this.state.route_id}
                          onChange={(e) => this.setState({ route_id: e.target.value })}
                          displayEmpty
                          label={t("Community")}
                          fullWidth={true}
                          required
                        >
                          {
                            this.state.routes.map((route, key) => {
                              if(route.type == "hierarchy"){
                                return <MenuItem key={key} value={key} disabled={true}>{route.route}</MenuItem>;
                              } else if(route.type == "multiple_routes"){
                                return <MenuItem key={key} value={key}>&nbsp;&nbsp;{route.route}</MenuItem>;
                              } else{
                                return <MenuItem key={key} value={key}>&nbsp;&nbsp;{route.route}</MenuItem>;
                              }
                            })
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                  }
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="material-types-select-label">{t("Material Type")}</InputLabel>
                      <Select
                        labelId="material-types-select-label"
                        value={this.state.material_type}
                        onChange={(e) => this.setState({ material_type: e.target.value })}
                        displayEmpty
                        label={t("Material Type")}
                        fullWidth={true}
                        required
                      >
                        {
                          this.state.materialTypes.map((materialType, key) => {
                            return <MenuItem key={key} value={materialType.id}>{materialType.name}</MenuItem>;
                          })
                        }
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="raw-material-kg-input"
                      label={t("Raw Material In KG")}
                      value={this.state.raw_material_in_kg}
                      type="number"
                      onChange={(e: any) => this.setState({ raw_material_in_kg: e.target.value })}
                      fullWidth={true}
                      required
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="sources-select-label">{t("Source")}</InputLabel>
                      <Select
                        labelId="sources-select-label"
                        value={this.state.source}
                        onChange={(e) => this.setState({ source: e.target.value })}
                        displayEmpty
                        label={t("Source")}
                        fullWidth={true}
                        // required
                      >
                        {
                          this.state.sources.map((source, key) => {
                            return <MenuItem key={key} value={source.id}>{source.name}</MenuItem>;
                          })
                        }
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Divider className='mt-3' />
              </CardContent>
              <CardActions className='float-right'>
                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddWasteByRawMaterial: false })}>{t("Close")}</Button>
                <Button size='small' type='submit' variant='contained' sx={{ outline: 'none !important' }}>{(!this.state.entryId) ? t("Add") : t("Edit")} {t("Waste")}</Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showAddWasteByMassUpload || this.state.editMassUpload}
          onClose={() => this.setState({ showAddWasteByMassUpload: false,editMassUpload:false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card
              component={"form"}
              onSubmit={(event: any) => handleAddWasteByMassUpload(event)}
            >
              <CardHeader
                title={t("Add Waste By Mass Upload")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() =>
                      this.setState({ showAddWasteByMassUpload: false,editMassUpload:false })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <CardActions className="mb-3">
                  <FormControl>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        inputFormat="yyyy-MM-dd"
                        views={['year', 'month', 'day']}
                        renderInput={(props) => <TextField {...props} />}
                        label={t("Date")}
                        value={this.state.date}
                        onChange={(newValue: any) => {
                          this.setState({ date: newValue });
                        }}
                        disableFuture={true}
                      />
                    </LocalizationProvider>
                  </FormControl>
                  <FormControl>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <TimePicker
                        inputFormat="HH:mm"
                        renderInput={(props) => <TextField {...props} />}
                        label={t("Time")}
                        value={this.state.time}
                        onChange={(newValue: any) => {
                          this.setState({ time: newValue });
                        }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </CardActions>
                <Divider className="mb-3" />
                <Grid container>
                  <Grid item md={12} xs={12}>
                    <TableContainer
                      component={Paper}
                      sx={{
                        boxShadow: 3,
                        height: "400px !important",
                        overflowY: "scroll",
                      }}
                    >
                      <Table sx={{ minWidth: 600 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Community Name")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Mixed Dry Waste")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Wet Waste")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Reject Waste")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Others")}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.routesRaw.map(
                            (route: any, key: number) => {
                              return (
                                <TableRow key={route.id}>
                                  <TableCell>{route.name}</TableCell>
                                  <TableCell>
                                    <TextField
                                      id="mixed-recyclables-kg-input"
                                      label={t("Mixed Dry Waste In KG")}
                                      type="number"
                                      defaultValue={ this.state.routesRecyclablesMappedToValue[route.id].kg}
                                      onChange={(e: any) =>
                                        handleMassUploadDataChange(
                                          key,
                                          "mixed_dry_waste",
                                          e.target.value,
                                          this.state.routesRecyclablesMappedToValue[route.id].edit_uuid 
                                        )
                                      }
                                      fullWidth={true}
                                      size="small"
                                      InputProps={{
                                        inputProps: { min: 0 },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      id="mixed-organics-kg-input"
                                      label={t("Wet Waste In KG")}
                                      type="number"
                                      defaultValue={ this.state.routesOrganicsMappedToValue[route.id].kg}
                                      onChange={(e: any) =>
                                        handleMassUploadDataChange(
                                          key,
                                          "wet_waste",
                                          e.target.value,
                                          this.state.routesRecyclablesMappedToValue[route.id].edit_uuid 
                                        )
                                      }
                                      fullWidth={true}
                                      size="small"
                                      InputProps={{
                                        inputProps: { min: 0 },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      id="residual-kg-input"
                                      label={t("Reject Waste In KG")}
                                      type="number"
                                      defaultValue={ this.state.routesResidualMappedToValue[route.id].kg}
                                      onChange={(e: any) =>
                                        handleMassUploadDataChange(
                                          key,
                                          "reject_waste",
                                          e.target.value,
                                          this.state.routesRecyclablesMappedToValue[route.id].edit_uuid 
                                        )
                                      }
                                      fullWidth={true}
                                      size="small"
                                      InputProps={{
                                        inputProps: { min: 0 },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      id="residual-kg-input"
                                      label={t("Others In KG")}
                                      type="number"
                                      defaultValue={ this.state.routesResidualMappedToValue[route.id].kg}
                                      onChange={(e: any) =>
                                        handleMassUploadDataChange(
                                          key,
                                          "others",
                                          e.target.value,
                                          this.state.routesRecyclablesMappedToValue[route.id].edit_uuid 
                                        )
                                      }
                                      fullWidth={true}
                                      size="small"
                                      InputProps={{
                                        inputProps: { min: 0 },
                                      }}
                                    />
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() =>
                    this.setState({ showAddWasteByMassUpload: false,editMassUpload:false })
                  }
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  type="submit"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                >
                  {t("Add Waste")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showAddWasteByWeighbridge || this.state.editWeighbridge}
          onClose={() => this.setState({ showAddWasteByWeighbridge: false,editWeighbridge:false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card
              component={"form"}
              onSubmit={(event: any) => handleAddWasteByWeighbridge(event)}
            >
              <CardHeader
                title={t("Show Add Waste By Weighbridge")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() =>
                      this.setState({ showAddWasteByWeighbridge: false,editWeighbridge:false })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="routes-select-label">
                        {t("Community")}
                      </InputLabel>
                      <Select
                        labelId="routes-select-label"
                        value={this.state.route_id}
                        onChange={(e) =>
                          this.setState({ route_id: e.target.value })
                        }
                        displayEmpty
                        label={t("Community")}
                        fullWidth={true}
                      >
                        {
                          this.state.routes.map((route, key) => {
                            if(route.type == "hierarchy"){
                              return <MenuItem key={key} value={key} disabled={true}>{route.route}</MenuItem>;
                            } else if(route.type == "multiple_routes"){
                              return <MenuItem key={key} value={key}>&nbsp;&nbsp;{route.route}</MenuItem>;
                            } else{
                              return <MenuItem key={key} value={key}>&nbsp;&nbsp;{route.route}</MenuItem>;
                            }
                          })
                        }
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          views={['year', 'month', 'day']}
                          renderInput={(props) => <TextField {...props} />}
                          label={t("Date")}
                          value={this.state.date}
                          onChange={(newValue: any) => {
                            this.setState({ date: newValue });
                          }}
                          disableFuture={true}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <TimePicker
                          inputFormat="HH:mm"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("Time")}
                          value={this.state.time}
                          onChange={(newValue: any) => {
                            this.setState({ time: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                    <Grid item md={4} xs={12}>
                      <TextField
                        required
                        id="truckPlateNumber"
                        label={t("Truck Plate Number")}
                        value={this.state.truckPlateNumber}
                        InputProps={{
                          inputProps: { min: 0, max: 100000000 },
                        }}
                        onChange={(e: any) =>
                          this.setState({
                            truckPlateNumber: e.target.value,
                            total_waste:
                              (this.state.vehicle_capacity * e.target.value) /
                              100,
                          })
                        }
                        fullWidth={true}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <FormControl fullWidth={true}>
                        <InputLabel id="material-types-select-label">
                          {t("Material Type")}
                        </InputLabel>
                        <Select
                          labelId="material-types-select-label"
                          value={this.state.material_type}
                          onChange={(e) =>
                            this.setState({ material_type: e.target.value })
                          }
                          displayEmpty
                          label={t("Material Type")}
                          fullWidth={true}
                          required
                        >
                          {this.state.materialTypes.map((materialType, key) => {
                            return (
                              <MenuItem key={key} value={materialType.id}>
                                {materialType.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <FormControl fullWidth={true}>
                        <InputLabel id="agent-ids">{t("Agents")}</InputLabel>
                        <Select
                          labelId="agent-ids"
                          type="string"
                          value={this.state.agentId} 
                          onChange={(e) =>
                            this.setState({ agentId: e.target.value })
                          }
                          displayEmpty
                          label={t("Material Type")}
                          fullWidth={true}
                          required
                        >
                          {this.state.agents.map((entry: any, key: any) => {
                            return (
                              <MenuItem key={key} value={entry.id}>
                                {entry.agent_name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
            
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="weight-of-truck-entering"
                      label={t("Weight Of Truck Entering")}
                      value={this.state.weightOfTruckEntering}
                      type="number"
                      onChange={(e) =>
                        this.setState({ weightOfTruckEntering: Number.parseInt(e.target.value) })
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                  <TextField
                      id="weight-of-truck-leaving"
                      label={t("Weight Of Truck Leaving")}
                      value={this.state.weightOfTruckLeaving}
                      type="number"
                      defaultValue='0'
                      onChange={(e) =>
                        this.setState({ weightOfTruckLeaving: Number.parseInt(e.target.value) })
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="weight-of-truck"
                      label={t("Weight Of Truck")}
                      defaultValue='0'
                      value= {  Math.abs(this.state.weightOfTruckEntering - this.state.weightOfTruckLeaving)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() =>
                    this.setState({ showAddWasteByWeighbridge: false,editWeighbridge:false })
                  }
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  type="submit"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                >
                  {t("Add Waste")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>

        <Modal
          open={this.state.showExportToCsv}
          onClose={() => this.setState({ showExportToCsv: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title={t("Export Data")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showExportToCsv: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          views={['year', 'month', 'day']}
                          renderInput={(props) => <TextField {...props} />}
                          label={t("From Date") + " *"}
                          value={this.state.fromDate}
                          onChange={(newValue: any) => {
                            this.setState({ fromDate: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          views={['year', 'month', 'day']}
                          renderInput={(props) => <TextField {...props} />}
                          label={t("To Date") + " *"}
                          value={this.state.toDate}
                          onChange={(newValue: any) => {
                            this.setState({ toDate: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showExportToCsv: false })}
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  disabled={!this.state.fromDate || !this.state.toDate}
                  onClick={() => handleExportToCsv()}
                >
                  {t("All")}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  disabled={!this.state.fromDate || !this.state.toDate}
                  onClick={() => handleExportOfIncomingWasteByVehicleCsv()}
                >
                  {t("Consolidated")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
                open={this.state.showCustomDateFilter}
                onClose={() => this.setState({ showCustomDateFilter: false })}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                <Box sx={style}>
                    <Card>
                    <CardHeader
                        title={t("Select Custom Analytics Dates")}
                        className="text-left"
                        action={
                        <IconButton
                            color="primary"
                            className="customIconButton"
                            aria-label="close"
                            component="span"
                            onClick={() =>
                            this.setState({ showCustomDateFilter: false })
                            }
                        >
                            <CloseOutlined />
                        </IconButton>
                        }
                    />
                    <CardContent>
                        <Divider className="mb-3" />
                        <Grid container spacing={2}>
                        <Grid item md={6} xs={12}>
                            <FormControl fullWidth={true}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                inputFormat="yyyy-MM-dd"
                                views={["year", "month", "day"]}
                                renderInput={(props) => <TextField {...props} />}
                                label={t("From Date") + " *"}
                                value={this.state.customFromDate}
                                onChange={(newValue: any) =>
                                    this.setState({ customFromDate: newValue })
                                }
                                />
                            </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <FormControl fullWidth={true}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                inputFormat="yyyy-MM-dd"
                                views={["year", "month", "day"]}
                                renderInput={(props) => <TextField {...props} />}
                                label={t("To Date") + " *"}
                                value={this.state.customToDate}
                                onChange={(newValue: any) =>
                                    this.setState({ customToDate: newValue })
                                }
                                />
                            </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        </Grid>
                        <Divider className="mt-3" />
                    </CardContent>
                    <CardActions className="float-right">
                        <Button
                        size="small"
                        className="customCloseButton"
                        onClick={() => this.setState({ showCustomDateFilter: false })}
                        >
                        {t("Close")}
                        </Button>
                        <Button
                        size="small"
                        variant="contained"
                        sx={{ outline: "none !important" }}
                        disabled={
                            !this.state.customFromDate || !this.state.customToDate
                        }
                        onClick={() => {
                            this.setState({ showCustomDateFilter: false });
                            this.fetchIncomingWasteList(0);
                        }}
                        >
                        {t("Get Analytics")}
                        </Button>
                    </CardActions>
                    </Card>
                </Box>
                </Modal>
        <Dialog
          open={this.state.showDeleteDialog}
          onClose={() => this.setState({ showDeleteDialog: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("Are you sure ? You want to delete this Entry ?")}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => this.setState({ showDeleteDialog: false })}>
              {t("Cancel")}
            </Button>
            <Button onClick={() => handleDeleteEntry()} autoFocus>
              {t("Ok")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(withTranslation()(IncomingWaste));
